<script setup lang="ts">
import {
  CounterProps,
  CounterTheme,
  CounterType,
  SizeClass
} from "./Counter.props"
import { getDigitSize } from "./Counter.util"

const props = withDefaults(defineProps<CounterProps>(), {
  masc: "0",
  separator: ":",
  countDownInHours: false,
  theme: CounterTheme.squared,
  type: CounterType.complete,
  sizeClass: SizeClass.dynoXl,
  gap: 0
})

const _seconds = 1000
const _minutes = _seconds * 60
const _hours = _minutes * 60
const _days = _hours * 24

let timer: any = null

const getContStringToDisplay = (item: number): string =>
  item.toString().padStart(2, props.masc)

const showRemaining = (date: string) => {
  timer = setInterval(() => {
    const now = new Date()
    const end = new Date(date)
    const distance = end.getTime() - now.getTime()

    if (distance < 0) {
      timer && clearInterval(timer)
      return
    }
    if (!props.countDownInHours) {
      const days = Math.floor(distance / _days)
      const hours = Math.floor((distance % _days) / _hours)
      countDown.days = days < 10 ? "0" + days : days.toString()
      countDown.hours = hours < 10 ? "0" + hours : hours.toString()
    } else {
      const hours = Math.floor(distance / _hours)
      countDown.hours = hours < 10 ? "0" + hours : hours.toString()
    }

    const minutes = Math.floor((distance % _hours) / _minutes)
    const seconds = Math.floor((distance % _minutes) / _seconds)

    countDown.minutes = minutes < 10 ? "0" + minutes : minutes.toString()
    countDown.seconds = seconds < 10 ? "0" + seconds : seconds.toString()
  }, 1000)
}

const digitSize = computed(() => getDigitSize(props.sizeClass))

const countDown = reactive({
  days: getContStringToDisplay(0),
  hours: getContStringToDisplay(0),
  minutes: getContStringToDisplay(0),
  seconds: getContStringToDisplay(0)
})

onMounted(() => {
  showRemaining(props.date)
})

onUnmounted(() => {
  timer && clearInterval(timer)
})
</script>
<template>
  <div>
    <section
      :class="[sizeClass, 'gap-' + gap]"
      class="flex content-center justify-center"
    >
      <AtomsCounterDigit
        v-if="!props.countDownInHours"
        :digit="countDown.days"
        label="giorni"
        :theme="theme"
        :type="type"
        :digitSize="digitSize"
      />
      <AtomsCounterSeparator
        v-if="!props.countDownInHours"
        :sparator="separator"
        :theme="theme"
        :type="type"
        :digitSize="digitSize"
      />
      <AtomsCounterDigit
        :digit="countDown.hours"
        label="ore"
        :theme="theme"
        :type="type"
        :digitSize="digitSize"
      />
      <AtomsCounterSeparator
        :sparator="separator"
        :theme="theme"
        :type="type"
        :digitSize="digitSize"
      />
      <AtomsCounterDigit
        :digit="countDown.minutes"
        label="minuti"
        :theme="theme"
        :type="type"
        :digitSize="digitSize"
      />
      <AtomsCounterSeparator
        :sparator="separator"
        :theme="theme"
        :type="type"
        :digitSize="digitSize"
      />
      <AtomsCounterDigit
        :digit="countDown.seconds"
        label="secondi"
        :theme="theme"
        :type="type"
        :digitSize="digitSize"
      />
    </section>
  </div>
</template>
<style lang="scss" scoped></style>
